import {
    COLLECTION_EXPORT_POPOVER_HIDE,
    COLLECTION_EXPORT_POPOVER_SHOW,
    COLLECTION_STATS_FETCH_ERROR,
    COLLECTION_STATS_FETCH_IN_PROGRESS,
    COLLECTION_STATS_FETCH_SUCCESS,
    COLLECTION_TAB_VALUE_SET,
    COLLECTION_TRANSFER_ADDRESS_SET,
    COLLECTION_TRANSFER_DIALOG_CONFIRMATION_SHOW,
    COLLECTION_TRANSFER_DIALOG_HIDE,
    COLLECTION_TRANSFER_DIALOG_SHOW,
    DENOM_SPLIT_INFO_SET,
    DENOM_SPLIT_INFO_STATUS_SET,
    DOWNLOAD_COLLECTION_NFT_S_ERROR,
    DOWNLOAD_COLLECTION_NFT_S_IN_PROGRESS,
    DOWNLOAD_COLLECTION_NFT_S_SUCCESS,
    JSON_TAB_SWITCH_SET,
    LISTED_FILTER_SET,
    LISTED_ON_SALE_IN_SEARCH_SET,
    LISTED_ON_SALE_IN_SET,
    LISTED_PRICE_RANGE_COIN_SET,
    LISTED_PRICE_RANGE_SET,
    LISTED_SEARCH_IN_PROGRESS_SET,
    LISTED_SEARCH_SET,
    NON_LISTED_SEARCH_IN_PROGRESS_SET,
    NON_LISTED_SEARCH_SET,
    NON_TRANSFERABLE_SEARCH_IN_PROGRESS_SET,
    NON_TRANSFERABLE_SEARCH_SET,
    UPDATE_COLLECTION_SET,
} from '../constants/collection';
import Axios from 'axios';
import { urlCollectionStats, urlDownloadCollectionNFTs } from '../constants/url';
import { handleErrorMessage } from '../utils/errorMessages';

export const setCollectionTabValue = (value) => {
    return {
        type: COLLECTION_TAB_VALUE_SET,
        value,
    };
};

export const showCollectionExportPopover = (event) => {
    return {
        type: COLLECTION_EXPORT_POPOVER_SHOW,
        anchorEl: event.currentTarget,
    };
};

export const hideCollectionExportPopover = () => {
    return {
        type: COLLECTION_EXPORT_POPOVER_HIDE,
    };
};

export const setJsonTabSwitch = (value) => {
    return {
        type: JSON_TAB_SWITCH_SET,
        value,
    };
};

// FILTER
export const setListedSearchInProgress = (value) => {
    return {
        type: LISTED_SEARCH_IN_PROGRESS_SET,
        value,
    };
};

export const setListedSearch = (value) => {
    return {
        type: LISTED_SEARCH_SET,
        value,
    };
};

export const setListedFilter = (value) => {
    return {
        type: LISTED_FILTER_SET,
        value,
    };
};

export const setListedOnSaleIn = (value) => {
    return {
        type: LISTED_ON_SALE_IN_SET,
        value,
    };
};

export const setListedOnSaleInSearch = (value) => {
    return {
        type: LISTED_ON_SALE_IN_SEARCH_SET,
        value,
    };
};

export const setListedPriceRange = (value) => {
    return {
        type: LISTED_PRICE_RANGE_SET,
        value,
    };
};

export const setListedPriceRangeCoin = (value) => {
    return {
        type: LISTED_PRICE_RANGE_COIN_SET,
        value,
    };
};

export const setUpdateCollection = (value) => {
    return {
        type: UPDATE_COLLECTION_SET,
        value,
    };
};

export const setNonListedSearch = (value) => {
    return {
        type: NON_LISTED_SEARCH_SET,
        value,
    };
};

export const setNonListedSearchInProgress = (value) => {
    return {
        type: NON_LISTED_SEARCH_IN_PROGRESS_SET,
        value,
    };
};

export const setNonTransferableSearch = (value) => {
    return {
        type: NON_TRANSFERABLE_SEARCH_SET,
        value,
    };
};

export const setNonTransferableSearchInProgress = (value) => {
    return {
        type: NON_TRANSFERABLE_SEARCH_IN_PROGRESS_SET,
        value,
    };
};

const downloadCollectionNFTsInProgress = () => {
    return {
        type: DOWNLOAD_COLLECTION_NFT_S_IN_PROGRESS,
    };
};

const downloadCollectionNFTsSuccess = (value) => {
    return {
        type: DOWNLOAD_COLLECTION_NFT_S_SUCCESS,
        value,
    };
};

const downloadCollectionNFTsError = (message) => {
    return {
        type: DOWNLOAD_COLLECTION_NFT_S_ERROR,
        message,
    };
};

export const downloadCollectionNFTs = (id, format, cb) => (dispatch) => {
    dispatch(downloadCollectionNFTsInProgress());

    const url = urlDownloadCollectionNFTs(id, format);
    Axios.get(url, {
        responseType: 'blob',
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(downloadCollectionNFTsSuccess(res.data));
            if (cb) {
                cb(res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(downloadCollectionNFTsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchCollectionStatsInProgress = () => {
    return {
        type: COLLECTION_STATS_FETCH_IN_PROGRESS,
    };
};

const fetchCollectionStatsSuccess = (value) => {
    return {
        type: COLLECTION_STATS_FETCH_SUCCESS,
        value,
    };
};

const fetchCollectionStatsError = (message) => {
    return {
        type: COLLECTION_STATS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchCollectionStats = (address, denom) => (dispatch) => {
    dispatch(fetchCollectionStatsInProgress());

    const url = urlCollectionStats(address, denom);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchCollectionStatsSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchCollectionStatsError(message));
        });
};

export const showCollectionTransferDialog = (value) => {
    return {
        type: COLLECTION_TRANSFER_DIALOG_SHOW,
        value,
    };
};

export const showCollectionTransferConfirmationDialog = () => {
    return {
        type: COLLECTION_TRANSFER_DIALOG_CONFIRMATION_SHOW,
    };
};

export const hideCollectionTransferDialog = () => {
    return {
        type: COLLECTION_TRANSFER_DIALOG_HIDE,
    };
};

export const setCollectionTransferAddress = (value) => {
    return {
        type: COLLECTION_TRANSFER_ADDRESS_SET,
        value,
    };
};

// split
export const setDenomSplitInfo = (value) => {
    return {
        type: DENOM_SPLIT_INFO_SET,
        value,
    };
};

export const setDenomSplitInfoStatus = (value, address) => {
    return {
        type: DENOM_SPLIT_INFO_STATUS_SET,
        value,
        address,
    };
};
